import { Component } from '@angular/core';

@Component({
    selector: 'app-dashboard',
    templateUrl: 'register.component.html',
    standalone: false
})
export class RegisterComponent {

  constructor() { }

}
